import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=122b1c09&scoped=true&"
import script from "./WelcomeCard.vue?vue&type=script&lang=js&"
export * from "./WelcomeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b1c09",
  null
  
)

export default component.exports